import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthDelegationService } from '@core/auth/auth-delegation.service';

@Injectable()
export class DelegationInterceptor implements HttpInterceptor {
  constructor(private authDelegationService: AuthDelegationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authDelegationService.isDelegatingSync()) {
      const delegationState = this.authDelegationService.getDelegationState();

      if (delegationState) {
        const delegationRequest = req.clone({
          setHeaders: {
            'X-Delegation': `${delegationState.delegationId}`,
          },
        });

        return next.handle(delegationRequest);
      }
    }

    return next.handle(req);
  }
}
